export default __webpack_public_path__ + "static/Graphik-Semibold-59cd93ffb9480e6b3d792bb956ff7e34.otf";